module.exports = __webpack_public_path__ + "static/media/ico_success.ca7b2777.svg";